import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Dropdown, Form } from 'components/HeroSemantic';

const DropdownWrapper = ({ labelId, onChange, options, placeholder, value }) => {
  const handleDropdownChange = (e, { value: selectedValue }) => {
    onChange(selectedValue);
  };

  return (
    <Form.Field inline>
      {typeof labelId === 'string' && (
        <label
          style={{ color: 'var(--owner-text)', fontSize: '14px', fontWeight: 700, lineHeight: '20px', margin: '20px', marginLeft: '10px' }}
          htmlFor={labelId}
          aria-label={labelId}
        >
          <FormattedMessage id={labelId} />
        </label>
      )}
      <Dropdown
        id={labelId}
        value={value}
        options={options}
        placeholder={placeholder}
        onChange={handleDropdownChange}
      />
    </Form.Field>
  );
};

DropdownWrapper.propTypes = {
  labelId: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.node,
  value: PropTypes.any,
};

export default DropdownWrapper;
